import { cn } from "@/utils/cn";
import { forwardRef, InputHTMLAttributes } from "react";

type OnboardingInputProps = InputHTMLAttributes<HTMLInputElement>;

/** Dark rounded text input of the v5 onboarding ("Input Tall Dark" in Figma). */
export const OnboardingInput = forwardRef<HTMLInputElement, OnboardingInputProps>(
  ({ className, ...props }, ref) => (
    <input
      {...props}
      ref={ref}
      className={cn(
        "h-[52px] w-full rounded-[40px] border border-white bg-black/10 px-5",
        "text-base font-medium text-white caret-[#bc9cf2] placeholder:text-[#eff1f5]/70",
        "focus:outline-none",
        className,
      )}
    />
  ),
);

OnboardingInput.displayName = "OnboardingInput";
